import React, { useState } from "react";
import { useTx } from "../../context/TxContext";
import { useToast } from "../common/Toast";
import { parseError } from "../../utils/errors";
import Icon from "../common/Icon";

// Generic admin action: inputs + one button.
// fields: [{ key, label, placeholder, hint }]
// onRun(values) -> must return a tx promise (we await tx.wait()).
export default function ActionForm({
  title, desc, icon = "spark", accent = "violet",
  fields = [], button, txLabel, onRun, onDone, danger,
}) {
  const [vals, setVals] = useState({});
  const { run } = useTx();
  const toast = useToast();

  const set = (k, v) => setVals((s) => ({ ...s, [k]: v }));

  const submit = async () => {
    for (const f of fields) {
      if (!String(vals[f.key] ?? "").trim()) {
        toast.error(`${f.label} is required.`);
        return;
      }
    }
    try {
      await run(txLabel || button, async () => {
        const tx = await onRun(vals);
        if (tx && tx.wait) await tx.wait();
      });
      toast.success(`${button} — done.`);
      setVals({});
      onDone && onDone();
    } catch (e) {
      toast.error(parseError(e));
    }
  };

  return (
    <div className={`card adm-card ${danger ? "danger" : ""}`}>
      <div className="adm-head">
        <span className={`adm-ico ${accent}`}><Icon name={icon} size={16} /></span>
        <div>
          <div className="adm-title">{title}</div>
          {desc && <div className="adm-desc muted">{desc}</div>}
        </div>
      </div>

      {fields.map((f) => (
        <div className="adm-field" key={f.key}>
          {f.label && <label className="field-label">{f.label}</label>}
          <input
            className="input"
            placeholder={f.placeholder || ""}
            value={vals[f.key] || ""}
            inputMode={f.numeric ? "decimal" : undefined}
            onChange={(e) => set(f.key, e.target.value)}
          />
          {f.hint && <div className="adm-hint muted">{f.hint}</div>}
        </div>
      ))}

      <button className={`btn btn-block ${danger ? "btn-danger" : ""}`} onClick={submit}>
        {button}
      </button>
    </div>
  );
}
